import { render, staticRenderFns } from "./WalletAgent.vue?vue&type=template&id=9055a5e6&scoped=true"
import script from "./WalletAgent.vue?vue&type=script&lang=js"
export * from "./WalletAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9055a5e6",
  null
  
)

export default component.exports